import { OptionType, OptionTypeSort } from './common';
import { leadShortInfoType } from './leadsApiTypes';

export const clientStatuses: Record<string, string> = {
  New: "Новый",
  Verified: "Верифицирован",
  LimitExceeded: "Лимит превышен",
  UnConfirmed: "Аккаунт не подтверждён",
  NotCompleteRegistration: "Регистрация не завершена"
};

export enum ClientTypesEnum {
  ul = 'ul',
  ip = 'ip'
}

export type ClientTypeOption = {
  label: string;
  value: ClientTypesEnum;
};

export enum ClientsSortEnum {
  createTimeDesc = 'createTimeDesc',
  createTime = 'createTime',
  companyName = 'companyName',
  companyNameDesc = 'companyNameDesc'
}

export const clientsDataSortType: OptionTypeSort[] = [
  { key: ClientsSortEnum.createTimeDesc, text: 'От новых к старым' },
  { key: ClientsSortEnum.createTime, text: 'От старых к новым' },
  { key: ClientsSortEnum.companyName, text: 'По имени компании А-Я' },
  { key: ClientsSortEnum.companyNameDesc, text: 'По имени компании Я-А' }
];

export const clientTypes: OptionType[] = []

export const reverseStatusMapping: Record<string, ClientStatusType> = {
  "Новый": "New",
  "Верифицирован": "Verified",
  "Лимит превышен": "LimitExceeded",
  "Аккаунт не подтверждён": "UnConfirmed",
  "Регистрация не завершена": "NotCompleteRegistration"
};

export type ClientStatusType = keyof typeof clientStatuses;

export type RoleType = "Клиент" | "Агент" | "Клиент агента";

export type PyrusStatusType = "Не синхронизирован" | "Синхронизирован";

export type AgentsList = {
  inn: string | null;
  userId: string;
  userName: string;
};

export type clientsAgentsListType = {
  clientCount: number;
  clients: clientAgentInfoType[];
  clientTypes: string[];
  clientStatuses: ClientStatusType[];
  agents: AgentsList[];
  managers: AgentsList[];
  pagination: PaginationType;
};

export type clientAgentInfoType = {
  inn: string;
  userId: string;
  companyName: string;
  role: RoleType;
  status: ClientStatusType;
  clientType: string;
  region: string;
  regionCode: number;
  timeZone: string;
  phone: string;
  manager?: string;
  hasPyrus: boolean;
  pyrusLink?: string;
  synchronizePyrus?: boolean | null;
  chatIdWithClient: number;
  localTime: string;
  registerDate: string;
  agent: {
    id: string | null;
    fio: string | null;
    inn: string | null;
  };
};

export type leadsListType = {
  leads: leadShortInfoType[];
  companyNames: string[];
  statuses: string[];
};

export type actType = {
  id: number;
  companyName: string;
  inn: string;
  period: string;
  changeDate: string;
  status: string;
  documentId: number;
  sum: number;
  isSigned: boolean;
  isReadySigned: boolean;
};

export type agentByInnType = {
  userId: string;
  inn: string;
  companyName: string;
  ceo: string;
  okved: string;
  region: string;
};

export type reqBodyDocUpload = {
  UserId?: string;
  Year?: number;
  Month?: number;
  Sum?: number;
  ActId?: number;
};

export type ManagerDownloadDocArgs = {
  userId: string;
  documentType: "passport" | "protocol";
};

export type PaginationType = {
  count: number;
  offset: number;
  total: number;
};

export type QueryParamsGetUsers = {
  sorting?: ClientsSortEnum;
  filter?: string;
  clientType?: string;
  agentId?: string;
  managerId?: string;
  registrationDate?: string; //for single date
  status?: string;
  onlyClient?: boolean;
  onlyAgent?: boolean;
  onlyAgentsClient?: boolean;
  existsInPyrus?: boolean;
  count?: number;
  offset?: number;
  startDate?: string;//next two for date range
  endDate?: string;
}